import React from 'react'

const Payment = ({ className = '', width = '1em', height = '1em', ...props }) => (
  <svg
    className={`ac-icon ac-icon__payment ${className}`}
    width={width}
    height={height}
    {...props}
    viewBox='0 0 24 24'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      d='M2 18h20v-8H2v8zM2 8h20V6H2v2zm21-4H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z'
    />
  </svg>
)

export default Payment
